import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import history from '../history'
import rootReducer from 'services/rootReducer'
import devToolsMiddleware from 'application/middleware/devToolsExtension'
import promiseMiddleware from 'application/middleware/promiseMiddleware'
import localCacheMiddleware from 'application/middleware/localCacheMiddleware'
import createLogger from 'redux-logger'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { notificationMiddleware } from 'application/middleware/notificationMiddleware'
import throttleMiddleware from 'application/middleware/reduxThrottle'
import unauthorizedMiddleware from 'application/middleware/unauthorizedMiddleware'
import actionListenerStoreEnhancer from './actionListenerStoreEnhancer'

const loggerMiddleware = createLogger({
  collapsed: true,
  predicate: (getState, action) => {
    if (!action || !action.type) { return }
    if (action.type.match(/redux-form/)) { return false }
    if (action.type.match(/@@route/)) { return false }
    return true
  },
})

export default function configureStore (initialState, apis = {}) {

  const middleware = [
    thunkMiddleware.withExtraArgument(apis),
    localCacheMiddleware(initialState.bootup.localCacheNonce),
    promiseMiddleware,
    throttleMiddleware,
    loggerMiddleware,
    unauthorizedMiddleware,
    notificationMiddleware,
    routerMiddleware(history),
  ]

  const store = createStore(
    connectRouter(history)(combineReducers(rootReducer)),
    initialState,
    compose(
      applyMiddleware(...middleware),
      actionListenerStoreEnhancer,
      devToolsMiddleware()
    )
  )

  return store
}
